module.exports = __webpack_public_path__ + "static/20-8e500ccf49ff6f99e5dbd81574d3bc1e.jpg";